import { useEffect } from "react";

// Runtime metadata complements build-time HTML. Reset page-owned tags on every
// route transition, including pages that do not supply structured data.
const DEFAULT_IMAGE = "https://www.fieldlink.co.nz/icon-512.png";

export function SEO({ title, description, path, ogImage, jsonLd, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("description", description);
    if (path || noindex) {
      for (const name of ["robots", "googlebot", "bingbot"]) setMeta(name, noindex ? "noindex,follow" : "index,follow");
    }
    if (!path) {
      document.querySelectorAll('link[rel="canonical"],meta[property="og:url"]').forEach(el => el.remove());
    }
    // Open Graph (Facebook, LinkedIn, WhatsApp, Discord)
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", "Fieldlink NZ", "property");
    if (path) setMeta("og:url", `https://www.fieldlink.co.nz${path === "/" ? "/" : path.replace(/\/+$/, "")}`, "property");
    setMeta("og:image", ogImage || DEFAULT_IMAGE, "property");
    // Twitter / X Cards
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage || DEFAULT_IMAGE);
    // Canonical
    if (path) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      document.querySelectorAll('link[rel="canonical"]').forEach(el => { if (el !== link) el.remove(); });
      link.setAttribute("href", `https://www.fieldlink.co.nz${path === "/" ? "/" : path.replace(/\/+$/, "")}`);
    }
    document.querySelectorAll('script[data-seo-page="true"]').forEach(el => el.remove());
    // Inject any per-page JSON-LD structured data (FAQPage, Product, etc.)
    if (jsonLd) {
      const arr = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      for (const data of arr) {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.dataset.seoPage = "true";
        s.textContent = JSON.stringify(data);
        document.head.appendChild(s);
      }
    }
    return () => document.querySelectorAll('script[data-seo-page="true"]').forEach(el => el.remove());
  }, [title, description, path, ogImage, jsonLd, noindex]);
  return null;
}

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
